module.exports = __webpack_public_path__ + "static/img/avatar-21.b6ffe0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-21.jpg
// module id = iPIh
// module chunks = 22